import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	//templateUrl: './edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblEventTypEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
		@Optional() public config?: DynamicDialogConfig,
		@Optional() public ref?: DynamicDialogRef,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate, config, ref);

		this.apiUrl = 'TblEventTyp';
		this.name = 'MENU.EVENT_TYP';
		this.url = '/' + PATH.EVENT_TYP;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: false, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
				{ type: 'color', key: 'VIRTUAL_primary_color', required: false, width: 400 },
				{ type: 'color', key: 'VIRTUAL_secondary_color', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}

	changeColor(pKey: string) {
		//console.log('changeColor!');
		//console.log(pKey);
		//console.log(this.entry[pKey]);
		//console.log(this.entry['colors']);
		//this.entry[pKey] = this.entry[pKey];
		//console.log(this.entry['colors']);
		//console.log(this.entry);

		// es gibt zwar einen Setter für VIRTUAL_primary_color/VIRTUAL_secondary_color,
		// aber das funktioniert von hier leider nicht; muss manuell gesetzt werden
		//if(pKey != null && pKey != undefined) {
		//	const strValue: string = this.entry[pKey];
		//	if(strValue != null && strValue != undefined && strValue.startsWith('#')) {
		//		let strCombinedValue: string = '';
		//		let strSecondValue: string = '';
		//		if(pKey === 'VIRTUAL_primary_color') {
		//			strSecondValue = this.entry['VIRTUAL_secondary_color'];
		//			if(strSecondValue == null || strSecondValue == undefined || strSecondValue.length < 1 || !strSecondValue.startsWith('#'))
		//				strSecondValue = '';
		//			strCombinedValue = strValue + ',' + strSecondValue;
		//		} else if(pKey === 'VIRTUAL_secondary_color') {
		//			strSecondValue = this.entry['VIRTUAL_primary_color'];
		//			if(strSecondValue == null || strSecondValue == undefined || strSecondValue.length < 1 || !strSecondValue.startsWith('#'))
		//				strSecondValue = '';
		//			strCombinedValue = strSecondValue + ',' + strValue;
		//		}
//
		//		// und zuweisen
		//		if(strCombinedValue.length > 1) {
		//			this.entry['colors'] = strCombinedValue;
		//		}
		//	}
		//}
		//console.log('colors: ' + this.entry['colors']);
		//console.log('primary: ' + this.entry['VIRTUAL_primary_color']);
		//console.log('secondary: ' + this.entry['VIRTUAL_secondary_color']);
	}
}
